import { curry, path } from "ramda"
import { isset } from "../validate"

const getMessage = curry((messages, fieldPath) => {
  if (!isset(messages)) return null
  return path(fieldPath, messages)
})

export default getMessage
